__turbopack_context__.v({
  "red": "Q7mtXa_red",
  "root": "Q7mtXa_root",
  "showButton": "Q7mtXa_showButton",
});
